export default {
  name: '璟馨婦幼醫院',
};
